export default __webpack_public_path__ + "static/media/add-button.35b87cf5.svg";